import type { ReactNode } from "react";
import { IconDocument, IconWhatsApp } from "./icons";
import { EmptyState } from "./EmptyState";
import { IconBarChart } from "./icons";

interface Props {
  title: string;
  subtitle?: string;
  height?: number;
  children?: ReactNode;
  isEmpty?: boolean;
  emptyMessage?: string;
  loading?: boolean;
  actions?: ReactNode;
  onExport?: () => void;
  onWhatsApp?: () => void;
  className?: string;
}

export function ChartCard({
  title, subtitle, height = 260, children, isEmpty = false,
  emptyMessage, loading = false, actions, onExport, onWhatsApp, className = "",
}: Props) {
  return (
    <div className={`card overflow-hidden ${className}`}>
      {/* Header */}
      <div className="px-5 py-4 border-b border-surface-border flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-gray-900">{title}</p>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-1">
          {actions}
          {onWhatsApp && (
            <button onClick={onWhatsApp} className="btn-ghost p-2 text-gray-400 hover:text-tm-600" title="Enviar no WhatsApp">
              <IconWhatsApp className="w-4 h-4" />
            </button>
          )}
          {onExport && (
            <button onClick={onExport} className="btn-ghost p-2 text-gray-400" title="Exportar">
              <IconDocument className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Body */}
      <div className="p-5">
        {loading ? (
          <div style={{ height }} className="bg-gray-50 rounded-lg animate-pulse" />
        ) : isEmpty ? (
          <div style={{ height }} className="flex items-center justify-center">
            <EmptyState
              icon={<IconBarChart className="w-6 h-6" />}
              title="Sem dados para exibir"
              description={emptyMessage ?? "Não há dados disponíveis para o período selecionado."}
              compact
            />
          </div>
        ) : (
          <div style={{ height }}>{children}</div>
        )}
      </div>
    </div>
  );
}
